import axios, {AxiosResponse} from 'axios';
import {handleError} from '../apis/errorHandling';

export interface Version {
    version: string;
    gitCommitId: string;
    buildDate: string;
}

export function version(): Promise<AxiosResponse<Version>> {
    return axios.get(`info/version`, {}).catch(handleError('error:loadingOfVersionFailed'));
}



// WEBPACK FOOTER //
// ./src/info/InfoAPI.ts